<template>
  <v-content>
    <v-container fluid>
      <v-row>
        <v-col  cols="12" xs="12" sm="12" lg="6">
          <EmployeeList />
        </v-col>
        <v-col  cols="12" xs="12" sm="12" lg="6">
          <v-container fluid class="pl-0 pr-0 pt-0">
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" class="pt-0">
                <MonthlyPrint />
              </v-col>
            </v-row>
          </v-container>

          <LatestLogs v-if="!this.$vuetify.breakpoint.xs && !this.$vuetify.breakpoint.sm" />
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import LatestLogs from "../components/Dashboard/LatestLogs";
import EmployeeList from "../components/Dashboard/EmployeeList";
import MonthlyPrint from "../components/Dashboard/MonthlyPrint";
export default {
  name: 'Home',

  components: {
    LatestLogs,
    EmployeeList,
    MonthlyPrint
  }

};
</script>
